import { useCreateWithdrawalRequest, useMyWithdrawalRequests, useWithdrawalMethods } from '@/hooks/useProviderWallet'
import { useState } from 'react'
import Button from '@/components/common/Button/Button'
import Input from '@/components/forms/Input/Input'
import Select from '@/components/forms/Select/Select'
import './ProviderWithdrawal.css'

const ProviderWithdrawal = () => {
    const { data: methods, isLoading: methLoading, isError: methError } = useWithdrawalMethods()
    const { data: withdrawals, isLoading, isError } = useMyWithdrawalRequests()
    const create = useCreateWithdrawalRequest()
    const [amount, setAmount] = useState('')
    const [methodId, setMethodId] = useState('')
    const [bankDetails, setBankDetails] = useState<Record<string, string>>({})

    const selected = (methods || []).find((m: any) => m.id === methodId)

    const handleSubmit = async () => {
        if (!amount || !methodId) return
        await create.mutateAsync({
            amount: Number(amount),
            payment_method_id: methodId,
            payment_method_name: selected?.name || methodId,
            bank_details: bankDetails,
        })
        setAmount('')
        setMethodId('')
        setBankDetails({})
    }

    return (
        <div className="provider-withdrawal-page">
            <div className="provider-withdrawal-container">
                <h1 className="provider-withdrawal-title">Retirar Fondos</h1>
                {methLoading ? (
                    <div className="provider-withdrawal-message">Cargando métodos...</div>
                ) : methError ? (
                    <div className="provider-withdrawal-message">Error al cargar métodos</div>
                ) : (
                    <div className="provider-withdrawal-form">
                        <Input name="amount" placeholder="Monto" value={amount} setValue={setAmount} effect3d={false} />
                        <Select label="Método" value={methodId} onChange={(e) => setMethodId(e.target.value)} options={(methods || []).map((m: any) => ({ value: m.id, label: m.name }))} placeholder="Selecciona método" />
                        {selected?.required_fields?.map((f: any) => (
                            <Input key={f.key} name={f.key} placeholder={f.label} value={bankDetails[f.key] || ''} setValue={(v) => setBankDetails({ ...bankDetails, [f.key]: v })} effect3d={false} />
                        ))}
                        <Button variant="primary" onClick={handleSubmit} disabled={create.isPending} effect3d={false}>Solicitar Retiro</Button>
                    </div>
                )}
                <h2 className="provider-withdrawal-subtitle">Mis Solicitudes</h2>
                {isLoading ? (
                    <div className="provider-withdrawal-message">Cargando...</div>
                ) : isError ? (
                    <div className="provider-withdrawal-message">Error al cargar solicitudes</div>
                ) : (
                    <div className="provider-withdrawal-list">
                        {(withdrawals || []).map((w: any) => (
                            <div key={w.id} className="provider-withdrawal-item">
                                <div><strong>{w.payment_method_name}</strong></div>
                                <div>S/ {w.amount}</div>
                                <div>{w.status_display || w.status}</div>
                            </div>
                        ))}
                        {(!withdrawals || withdrawals.length === 0) && (
                            <div className="provider-withdrawal-message">No hay solicitudes aún</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default ProviderWithdrawal


